import { Component, ViewChild } from '@angular/core';
import { ReusableInfoConfirmComponent } from '../reusable-info-confirm/reusable-info-confirm.component';
import { ErrorAlertComponent } from '../error-alert/error-alert.component';
import { merge, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { TmModalCloseReason } from '../../entity/TmModalCloseReason';

@Component({
  selector: 'tm-reusable-error-alert',
  templateUrl: './reusable-error-alert.component.html',
  styleUrls: ['./reusable-error-alert.component.css']
})
export class ReusableErrorAlertComponent extends ReusableInfoConfirmComponent {
  /** 實體的訊息確認窗 */
  @ViewChild(ErrorAlertComponent, {static: false}) set infoConfirm(c: ErrorAlertComponent) {
    if (c) {
      this._infoConfirm = c;
      this.setPendingDatas();
    }
  }
  get infoConfirm() { return this._infoConfirm as ErrorAlertComponent; }
  _pendingShowCopyButton?: boolean;
  set showCopyButton(s: boolean) {
    if (this.infoConfirm) {
      this.infoConfirm.showCopyButton = s;
      this._pendingShowCopyButton = undefined;
    } else {
      this._pendingShowCopyButton = s;
    }
  }
  get showCopyButton(): boolean | undefined {
    if (this.infoConfirm) {
      return this.infoConfirm.showCopyButton;
    }
    return this._pendingShowCopyButton || false;
  }

  protected setPendingDatas() {
    super.setPendingDatas();
    if (this._pendingShowCopyButton) { this.showCopyButton = this._pendingShowCopyButton; }
  }

  open(message: string, param: {title: string, afterClose?: () => void, afterConfirm?: () => void, showCopyTip?: boolean}) {
    const cached: any = {
      message: (message),
      param: (param),
    };
    this.cachedInfos.push(cached);
    const cIndex = this.cachedInfos.length - 1;
    this.setInfo(cached, cIndex);

    if (this.infoConfirm && this.infoConfirm.modal && !this.infoConfirm.modal.isOpened) {
      this.infoConfirm.open();
    }
  }

  protected setInfo(
    cached: {
      message: string;
      param: {title: string, afterClose?: () => void, afterConfirm?: () => void, showCopyTip?: boolean};
      closeSubc?: Subscription;
    },
    cacheIndex: number
  ) {
    this.infoConfirm.message = cached.message;
    if (cached.param) {
      if (cached.param.title) {
        this.infoConfirm.title = cached.param.title;
      }
      if (cached.param.showCopyTip) {
        this.infoConfirm.showCopyButton = true;
      } else {
        this.infoConfirm.showCopyButton = false;
      }
      if (this.cachedInfos.length > 1) {
        this.cachedInfos[this.cachedInfos.length - 2].closeSubc.unsubscribe();
      }
    }

    let closeReason: TmModalCloseReason = TmModalCloseReason.SUBMIT;
    cached.closeSubc = merge(
      this.infoConfirm.afterConfirm.pipe(tap(() => { closeReason = TmModalCloseReason.SUBMIT })),
      this.infoConfirm.afterCancel.pipe(tap(() => { closeReason = TmModalCloseReason.CLOSE })),
    ).pipe(take(1)).subscribe(() => {
      if (closeReason === TmModalCloseReason.SUBMIT) {
        if (cached.param && cached.param.afterConfirm) {
          cached.param.afterConfirm();
        }
      } else {
        if (cached.param && cached.param.afterClose) {
          cached.param.afterClose();
        }
      }
      this.cachedInfos.splice(cacheIndex, 1);
      if (this.cachedInfos.length > 0) {
        const cIndex = this.cachedInfos.length - 1;
        const nextCachedAlert = this.cachedInfos[cIndex];
        this.setInfo(nextCachedAlert, cIndex);
        this.infoConfirm.open();
      }
    });
  }
}
